import { layoutPubSub } from './layout-model.js';

export const onUpdateTheme = (theme: 'dark' | 'light') => {
  layoutPubSub.publish('updateTheme', { theme });
};
